// extracted by mini-css-extract-plugin
export default {"Fhcheader":"fhcheader_Fhcheader__twFKS","subscribebtn":"fhcheader_subscribebtn__YhUeL"};